if (!customElements.get('image-steps')) {
  class ImageSteps extends HTMLElement {
    constructor() {
      super();

      this.currentIndex = 0;

      this.handleClickBind = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll('.image-steps__step-button');
      this.images = this.querySelectorAll('.image-steps__image');
      this.addEventListener('click', this.handleClickBind);
      this.autoPlay();
    }

    disconnectedCallback() {
      console.log('ImageSteps disconnectedCallback');
      this.removeEventListener('click', this.handleClickBind);
    }

    autoPlay() {
      setTimeout(this.autoPlayStep.bind(this), 5000);
    }

    autoPlayStep() {
      if (this.matches(':hover, :focus')) {
        this.autoPlay();
        return;
      }

      this.currentIndex = 
        this.currentIndex + 1 < this.buttons.length ?
        this.currentIndex + 1 :
        0;

      this.closeAll();
      this.open(this.buttons[this.currentIndex]);
      this.autoPlay();
    }

    handleClick(evt) {
      const button = evt.target.closest('.image-steps__step-button');

      if (button) {
        this.closeAll();
        this.open(button);
        this.buttons.forEach((button, i) => {
          if (button.getAttribute('aria-expanded') === 'true') {
            this.currentIndex = i;
          }
        });
      }
    }

    closeAll() {
      this.buttons.forEach(button => {
        button.setAttribute('aria-expanded', false);
      });
      this.images.forEach(image => {
        image.setAttribute('aria-hidden', true);
      });
    }

    open(button) {
      const image = this.querySelector(`#${button.getAttribute('aria-controls')}`);

      if (image) {
        button.setAttribute('aria-expanded', true);
        image.setAttribute('aria-hidden', false);
      }
    }
  }

  customElements.define('image-steps', ImageSteps);
}
